import { ChangeEvent, FC } from 'react'
import { Select, Text } from '@leroy-merlin-br/backyard-react'

import * as S from '../styled'
import { SelectData } from '../types'

interface FavoriteStoreFieldProps {
  favoriteStores: SelectData[]
  loading: boolean
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  value: string
  isError?: boolean
  isFavoriteStoreFieldReadonly?: boolean
}

const FavoriteStoreField: FC<FavoriteStoreFieldProps> = ({
  favoriteStores,
  loading,
  onChange,
  value,
  isError,
  isFavoriteStoreFieldReadonly
}) => {
  return (
    <S.Field>
      <S.SelectWrapper
        style={{ display: isFavoriteStoreFieldReadonly ? 'none' : 'block' }}>
        <Select
          disabled={loading}
          label={
            <S.Label>
              <Text color="n800" size="mega" isBold>
                Qual sua loja favorita?
              </Text>
            </S.Label>
          }
          options={favoriteStores}
          onChange={onChange}
          placeholder="Selecione sua loja favorita"
          value={value}
          state={isError ? 'invalid' : undefined}
          hint={isError ? 'Escolha uma opção de loja favorita' : undefined}
        />
      </S.SelectWrapper>

      {isFavoriteStoreFieldReadonly && (
        <>
          <S.Label>
            <Text color="n800" size="mega" isBold>
              Qual sua loja favorita?
            </Text>
          </S.Label>
          <Text color="n700" size="mega">
            {favoriteStores.find(store => store.value === value)?.label}
          </Text>
        </>
      )}
    </S.Field>
  )
}

export default FavoriteStoreField
